import { ImplantReportType } from 'common/types'

export enum OrganizationTypeEnum {
  Vendor = 'Vendor',
  Hospital = 'Hospital',
  SurgeryCenter = 'SurgeryCenter',
  OMFS = 'OMFS',
}

export type TOrganization = {
  id: string
  name: string
  type: OrganizationTypeEnum
  auth0OrganizationName: string
  auth0OrganizationId: string
  organizationId: string
  emailFooter: string
  emailHeader: string
  logoUrl: string
  reports: (keyof typeof ImplantReportType)[]
  emailAddress: string
}

export type TPatientStatusOption = {
  id: number
  value: string
  status: string
  color: string
  displayText: string
}
